import React from 'react'

const TONES = {
  success: 'bg-success bg-opacity-10 text-success',
  warning: 'bg-orange-500 bg-opacity-10 text-orange-500',
  danger: 'bg-danger bg-opacity-10 text-danger',
  primary: 'bg-primary bg-opacity-10 text-primary'
}

export default function StatusPill({ text, tone = 'success' }) {
  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-md text-xs font-medium whitespace-nowrap ${TONES[tone] || TONES.success}`}>
      {text}
    </span>
  )
}
